import UserProductsDB from '@/firebase/user-products-db';
import userDB from '@/firebase/users-db';
import { createNewPost } from '@/misc/helpers';
import router from '../../router';
import { database } from '@/firebase/async-firestore';
import { async } from 'q';

export default {
    /**
     * Fetch products of current loggedin user
     */
    getUserProducts: async({ rootState, commit }) => {
        const userProductDb = new UserProductsDB(rootState.user.currentUser.uid);

        const products = await userProductDb.readAll();
        commit('SET_PRODUCTS', products);
    },

    /** 
     * update card deck after drag/drop
     */
    updateCardDesk: async({ commit, rootState }, payload) => {
        const UserProDB = new UserProductsDB(rootState.user.currentUser.uid);

        commit('setProductCreationPending', true);

        await UserProDB.updateInside(
            payload.selectedContent,
            payload.path,
            payload.uuid,
        );
    },
    triggerUpdateDesk: ({ dispatch }, payload) => {
        dispatch('updateCardDesk', payload);
    },

    updateAll: async({ commit }, payload) => {
        commit("SET_PRODUCTS", payload)

    },
    triggerUpdateAll: ({ dispatch }, payload) => {
        dispatch('updateAll', payload);
    },

    /**
     * Update activity for product
     */
    updateActivity: async({ commit, rootState, state }, payload) => {
        commit('setProductCreationPending', true);
        const userProductDb = new UserProductsDB(rootState.user.currentUser.uid);

        await userProductDb.updateInside(
            payload.selectedContent,
            payload.path,
            payload.uuid
        );

        const index = state.products.findIndex(item => item.uuid === payload.uuid);
        if (index !== -1) state.products.splice(index, 1, payload.newData);

        commit('setProductCreationPending', false);
    },

    triggerAddProductActionActivity: ({ dispatch }, payload) => {
        const product = payload;
        dispatch('updateActivity', product);
    },

    /**
     * Create a product for current loggedin user
     */
    createUserProduct: async({ commit }, payload) => {
        commit('setProductCreationPending', true);
        const post = await createNewPost(payload.postData);

        commit('user/SET_LASTPOS', payload.pos, { root: true });

        commit('addProductPosts', post);
        commit('addProduct', post);
        commit('setProductCreationPending', false);
    },

    triggerAddProductAction: ({ dispatch }, payload) => {
        const product = payload;
        dispatch('createUserProduct', product);
    },

    /**
     * Delete a user product from its id
     */
    deleteUserProduct: async({ rootState, commit, getters }, productId) => {
        if (getters.isProductDeletionPending(productId)) return;

        const userProductsDb = new UserProductsDB(rootState.user.currentUser.uid);

        commit('user/SET_LASTPOSMINUS', 0, { root: true });
        commit('addProductDeletionPending', productId);
        await userProductsDb.delete(productId);
        commit('removeProductById', productId);
        commit('removeProductDeletionPending', productId);
    },

    /**
     * update in posts collection { 'desc' }
     */
    updateUserProduct: async({ commit, rootState }, payload) => {
        const userId = rootState.user.currentUser.uid;
        const userProductDb = new UserProductsDB(userId);

        commit('setProductCreationPending', true);
        await userProductDb.updateInside(
            payload.selectedContent.name,
            payload.path,
            payload.uuid
        );
        commit('SET_NAME', payload.selectedContent.name);

        await userProductDb.updateInside(
            payload.selectedContent.desc,
            payload.path2,
            payload.uuid
        );
        commit('SET_DESC', payload.selectedContent.name);

        await userProductDb.updateInside(
            payload.selectedContent.website,
            payload.path3,
            payload.uuid
        );
        commit('SET_WEBSITE', payload.selectedContent.name);
        commit('setProductCreationPending', false);
    },

    triggerUpdateProductAction: ({ dispatch }, payload) => {
        dispatch('updateUserProduct', payload);
    },

    /**
     * delete all cards
     */
    deleteAllUserCards: async({ rootState, commit, dispatch, getters },
        productId
    ) => {
        if (getters.isProductDeletionPending(productId)) return;

        const userProductsDb = new UserProductsDB(rootState.user.currentUser.uid);
        await userProductsDb.deleteAll();

        const userdb = new userDB(rootState.user.currentUser.uid)
        await userdb.updateInside(0, 'last_position', rootState.user.currentUser.uid)

        commit('user/SET_STATENULL', 0, { root: true });

        (await database())
        .ref('notify/' + rootState.user.currentUser.uid)
            .remove();

        commit('SET_PRODUCTS', []);
        commit('addProductDeletionPending', productId);
        commit('removeProductById', productId);
        commit('removeProductDeletionPending', productId);
    },

    /**
     * activate all cards
     */
    activateCard: async({ rootState, state, commit }, payload) => {
        if (state.products.length <= 1) {
            return;
        } else {
            const userProductsDb = new UserProductsDB(
                rootState.user.currentUser.uid
            );
            await userProductsDb.putAllToActive();

            state.products.forEach(doc => {
                const newData = {
                    name: doc.name,
                    desc: doc.desc,
                    active: true,
                    view: doc.view,
                    priority: doc.priority,
                    uuid: doc.uuid,
                };
                const index = state.products.findIndex(item => item.uuid === doc.uuid);
                if (index !== -1) state.products.splice(index, 1, newData);
            });
        }
    },

    deActiveAllCards: async({ rootState, state, getters, commit }, productId) => {
        if (state.products.length <= 1) {
            return;
        } else {
            if (getters.isProductDeletionPending(productId)) return;

            const userProductsDb = new UserProductsDB(
                rootState.user.currentUser.uid
            );

            await userProductsDb.putAllToDeActive();

            state.products.forEach(doc => {
                const newData = {
                    name: doc.name,
                    desc: doc.desc,
                    active: false,
                    view: doc.view,
                    priority: doc.priority,
                    uuid: doc.uuid,
                };
                const index = state.products.findIndex(item => item.uuid === doc.uuid);
                if (index !== -1) state.products.splice(index, 1, newData);
            });
        }
    },
    ACTIVE: async({ commit }) => {
        commit('SET_ACTIVE', true);
    },
    DEACTIVE: async({ commit }) => {
        commit('SET_ACTIVE', false);
    },
};